module.exports = __webpack_public_path__ + "img/gg_small_new.2521eb33.jpg";